// extracted by mini-css-extract-plugin
module.exports = {"type":"type__2BmAM","attaches":"attaches__2DafF","label":"label__1aIBH"};